// packages/ui-kit/src/people/RoleBadge.tsx
// C3F v18 — reference: design/system/components/people/RoleBadge.{jsx,prompt.md}
// Always neutral outline: a role is read, it does not alarm. The previous
// accent/info tone-per-role mapping spent state colors on hierarchy.
import { Badge } from "../primitives/Badge.js";

type Role = "tenant_owner" | "manager_hotel" | "manager_functional" | "staff";

// Italian labels are fixed: "owner" is "Titolare", never "proprietario".
const labels: Record<Role, string> = {
  tenant_owner: "Titolare",
  manager_hotel: "Responsabile",
  manager_functional: "Responsabile funzionale",
  staff: "Staff",
};

export function RoleBadge({ role, label }: { role: Role; label?: string }) {
  return (
    <Badge tone="neutral" variant="outline" size="sm" className="whitespace-nowrap">
      {label ?? labels[role]}
    </Badge>
  );
}
